import * as RadixDialog from '@radix-ui/react-dialog'
import { styled } from '../../../config'

export const Portal = styled(RadixDialog.Portal)
